import * as React from 'react';

interface FDateProps {
  className?: string;
  style?: React.CSSProperties;

  onClick?(): void;
}

/** Figma icon_date 14×14 */
function FDate({ className, style, onClick }: FDateProps) {
  return (
    <svg
      className={className}
      style={style}
      onClick={onClick}
      width={14}
      height={14}
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-hidden
    >
      <path d="M4.375 10.9375H2.625V9.1875H4.375V10.9375Z" fill="currentColor" />
      <path d="M7.875 10.9375H6.125V9.1875H7.875V10.9375Z" fill="currentColor" />
      <path d="M11.375 10.9375H9.625V9.1875H11.375V10.9375Z" fill="currentColor" />
      <path d="M4.375 8.09375H2.625V6.34375H4.375V8.09375Z" fill="currentColor" />
      <path d="M7.875 8.09375H6.125V6.34375H7.875V8.09375Z" fill="currentColor" />
      <path d="M11.375 8.09375H9.625V6.34375H11.375V8.09375Z" fill="currentColor" />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.15625 1.75H9.84375V0.875H10.7188V1.75H12.25C13.2165 1.75 14 2.5335 14 3.5V11.375C14 12.3415 13.2165 13.125 12.25 13.125H1.75C0.783502 13.125 0 12.3415 0 11.375V3.5C0 2.5335 0.783502 1.75 1.75 1.75H3.28125V0.875H4.15625V1.75ZM0.875 11.375L0.876068 11.4201C0.899525 11.8824 1.28187 12.25 1.75 12.25H12.25L12.2951 12.2489C12.7574 12.2255 13.125 11.8431 13.125 11.375V5.03125H0.875V11.375ZM1.75 2.625C1.26675 2.625 0.875 3.01675 0.875 3.5V4.15625H13.125V3.5C13.125 3.03187 12.7574 2.64953 12.2951 2.62607L12.25 2.625H10.7188V3.28125H9.84375V2.625H4.15625V3.28125H3.28125V2.625H1.75Z"
        fill="currentColor"
      />
    </svg>
  );
}

export default FDate;
